(() => {
  // Single module-level Escape handler that closes any currently open drawer.
  // Per-toggle binding previously stacked up document listeners on Shopify
  // section reloads because the headerDrawerBound flag lives on the toggle
  // element (which gets replaced on reload).
  const openCloseFns = new Set();
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || openCloseFns.size === 0) return;
    openCloseFns.forEach((fn) => {
      try { fn(); } catch (_) {}
    });
  });

  const initDrawer = (toggle) => {
    if (!(toggle instanceof HTMLElement)) return;
    if (toggle.dataset.headerDrawerBound === "true") return;
    toggle.dataset.headerDrawerBound = "true";

    const drawerId = toggle.getAttribute("aria-controls");
    if (!drawerId) return;
    const drawer = document.getElementById(drawerId);
    if (!(drawer instanceof HTMLElement)) return;

    const ensureOverlay = () => {
      let overlay = document.querySelector(".header-v2__page-overlay");
      if (!overlay) {
        overlay = document.createElement("div");
        overlay.className = "header-v2__page-overlay";
      }
      if (overlay.parentElement !== document.body) {
        document.body.appendChild(overlay);
      }
      return overlay;
    };

    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    const closeButtons = drawer.querySelectorAll("[data-header-drawer-close]");
    const overlay = ensureOverlay();
    const firstLink = drawer.querySelector(".header-v2__drawer-link");
    const countrySelect = drawer.querySelector(
      ".header-v2__locale-form select[name='country_code']"
    );
    let closeTimer;

    if (countrySelect instanceof HTMLSelectElement) {
      countrySelect.addEventListener("change", () => {
        const form = countrySelect.form;
        if (!(form instanceof HTMLFormElement)) return;

        // A header section can be re-rendered without a page navigation. Keep
        // Shopify's return target in step with the page the customer is
        // actually viewing, including PDP view/experiment parameters.
        const returnTo = form.querySelector("input[name='return_to']");
        if (returnTo instanceof HTMLInputElement) {
          returnTo.value = window.location.pathname + window.location.search;
        }

        form.setAttribute("aria-busy", "true");
        if (typeof form.requestSubmit === "function") {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }

    const closeSearch = () => {
      const header = document.querySelector("sht-header");
      const predictive = document.querySelector("sht-predictive-srch");
      if (predictive && typeof predictive.closeSearchResults === "function") {
        predictive.closeSearchResults(true);
      }
      if (predictive) {
        predictive.removeAttribute("open");
      }
      if (header) {
        header.classList.remove("header--predictive-search-open");
      }
      document.body.classList.remove("search-open");
      document.body.classList.remove("o-hidden");
    };

    const closeDrawer = () => {
      drawer.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      document.body.classList.remove("header-v2--drawer-open");
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        drawer.hidden = true;
      }, 220);
      openCloseFns.delete(closeDrawer);
    };

    const openDrawer = () => {
      window.clearTimeout(closeTimer);
      if (document.body.classList.contains("search-open")) {
        closeSearch();
      }
      drawer.hidden = false;
      requestAnimationFrame(() => {
        drawer.classList.add("is-open");
      });
      document.body.classList.add("header-v2--drawer-open");
      toggle.setAttribute("aria-expanded", "true");
      if (firstLink instanceof HTMLElement) {
        firstLink.focus({ preventScroll: true });
      }
      openCloseFns.add(closeDrawer);
    };

    toggle.addEventListener("click", (event) => {
      event.preventDefault();
      if (drawer.classList.contains("is-open")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    drawer.addEventListener("click", (event) => {
      if (event.target === drawer) {
        closeDrawer();
      }
    });

    closeButtons.forEach((btn) => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();
        closeDrawer();
      });
    });

    if (overlay) {
      overlay.addEventListener("click", closeDrawer);
    }
  };

  const boot = () => {
    document.querySelectorAll("[data-header-drawer-toggle]").forEach(initDrawer);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
